(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ilamo-collection-luxury"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.ilcReady === 'true') return;
      section.dataset.ilcReady = 'true';

      section.querySelectorAll('[data-ilc-sort]').forEach((select) => {
        select.addEventListener('change', () => select.form && select.form.requestSubmit());
      });

      const grid = section.querySelector('[data-ilc-grid]');
      section.querySelectorAll('[data-ilc-view]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!grid) return;
          const isList = button.dataset.ilcView === 'list';
          grid.classList.toggle('is-list', isList);
          section.querySelectorAll('[data-ilc-view]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });

      section.querySelectorAll('[data-ilc-filter-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const drawer = button.closest('.ilc__mobile-filter');
          if (drawer) drawer.removeAttribute('open');
        });
      });
    };

    document.querySelectorAll('[data-ilamo-collection]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ilamo-collection]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilamo-newsletter-popup"]) return;
  try {
    
  (() => {
    const selector = '[data-ilamo-newsletter-popup]';

    const readStorage = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (error) {
        return;
      }
    };

    const initPopup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-ilnp-dialog]');
      const card = root.querySelector('.ilnp__card');
      const email = root.querySelector('input[type="email"]');
      const success = root.querySelector('[data-ilnp-success]');
      const errorState = root.querySelector('[data-ilnp-error]');
      const copyButton = root.querySelector('[data-ilnp-copy]');
      const codeElement = root.querySelector('[data-ilnp-code]');
      const copyStatus = root.querySelector('[data-ilnp-copy-status]');
      const continueButton = root.querySelector('[data-ilnp-continue]');
      const closeButtons = root.querySelectorAll('[data-ilnp-close]');
      const shopKey = root.dataset.shopKey || window.location.host;
      const keyBase = `ilamo-newsletter-popup:v1:${shopKey}`;
      const closedKey = `${keyBase}:closed-at`;
      const subscribedKey = `${keyBase}:subscribed`;
      const shownKey = `${keyBase}:shown`;
      const delay = Math.max(0, Number(root.dataset.delaySeconds) || 0) * 1000;
      const cooldown = Math.max(1, Number(root.dataset.cooldownDays) || 7) * 86400000;
      const isDesignMode = root.dataset.designMode === 'true';
      const mobileEnabled = root.dataset.mobileEnabled === 'true';
      const exitIntentEnabled = root.dataset.exitIntent === 'true';
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      let previousFocus = null;
      let timer = null;

      if (!dialog || !card || window.location.pathname.includes('/checkouts/')) return;

      const focusableElements = () => Array.from(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.offsetParent !== null);

      const openPopup = (force = false) => {
        if (dialog.open) return;
        if (!force && isMobile && !mobileEnabled) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('ilnp-lock');
        writeStorage(sessionStorage, shownKey, '1');
        window.requestAnimationFrame(() => {
          // Automatic opening must not raise the mobile keyboard or pre-activate CAPTCHA.
          const target = success ? copyButton || continueButton : errorState ? email || closeButtons[0] : closeButtons[0] || email;
          target?.focus({ preventScroll: true });
        });
      };

      const closePopup = (remember = true) => {
        if (!dialog.open) return;
        dialog.close();
        document.documentElement.classList.remove('ilnp-lock');
        if (remember && !success) writeStorage(localStorage, closedKey, String(Date.now()));
        if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
      };

      closeButtons.forEach((button) => button.addEventListener('click', () => closePopup(true)));
      continueButton?.addEventListener('click', () => closePopup(false));

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup(true);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closePopup(true);
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const items = focusableElements();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      copyButton?.addEventListener('click', async () => {
        const code = codeElement?.textContent.trim();
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          copyButton.textContent = copyButton.dataset.copiedLabel || 'KOPIERT';
          if (copyStatus) copyStatus.textContent = 'Rabattcode kopiert';
        } catch (error) {
          if (copyStatus) copyStatus.textContent = 'Bitte Code manuell kopieren';
        }
      });

      if (success) {
        writeStorage(localStorage, subscribedKey, '1');
        openPopup(true);
        return;
      }

      if (errorState) {
        openPopup(true);
        return;
      }

      if (isDesignMode) {
        timer = window.setTimeout(() => openPopup(true), 250);
        return;
      }

      if (isMobile && !mobileEnabled) return;
      if (readStorage(localStorage, subscribedKey) === '1') return;
      if (readStorage(sessionStorage, shownKey) === '1') return;

      const closedAt = Number(readStorage(localStorage, closedKey));
      if (closedAt && Date.now() - closedAt < cooldown) return;

      timer = window.setTimeout(() => openPopup(false), delay);

      if (exitIntentEnabled && !isMobile) {
        const handleExitIntent = (event) => {
          if (event.relatedTarget || event.clientY > 0 || dialog.open) return;
          if (timer) window.clearTimeout(timer);
          openPopup(false);
          document.removeEventListener('mouseout', handleExitIntent);
        };
        document.addEventListener('mouseout', handleExitIntent);
      }
    };

    document.querySelectorAll(selector).forEach(initPopup);
    document.addEventListener('shopify:section:load', (event) => {
      initPopup(event.target.querySelector(selector));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
